import { ReactElement, ReactNode, SVGProps } from 'react';

type PreviewIconProps = SVGProps<SVGSVGElement> & {
  size: number;
  children: ReactNode;
};

function PreviewIcon({ size, children, ...props }: PreviewIconProps): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function TimingPreviewGauge(): ReactElement {
  return (
    <PreviewIcon size={20}>
      <path className="timing-preview-gauge-needle" d="m12 14 4-4" />
      <path d="M3.34 19a10 10 0 1 1 17.32 0" />
    </PreviewIcon>
  );
}

export function TimingPreviewPlay(): ReactElement {
  return (
    <PreviewIcon size={16} className="timing-preview-play">
      <polygon points="6 3 20 12 6 21 6 3" />
    </PreviewIcon>
  );
}

export function TimingPreviewPause(): ReactElement {
  return (
    <PreviewIcon size={16}>
      <rect className="timing-preview-pause-right" x={14} y={4} width={4} height={16} rx={1} />
      <rect className="timing-preview-pause-left" x={6} y={4} width={4} height={16} rx={1} />
    </PreviewIcon>
  );
}

export function TimingPreviewRestart(): ReactElement {
  return (
    <PreviewIcon size={16} className="timing-preview-restart">
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
    </PreviewIcon>
  );
}
